export default __webpack_public_path__ + "static/media/52t.7b1bd922.jpg";